const createSseParser = (onEvent) => {
  let buffer = '';
  let currentEvent = 'message';
  let currentId = null;
  let dataLines = [];

  const flushEvent = () => {
    if (!dataLines.length && !currentId) {
      currentEvent = 'message';
      currentId = null;
      return;
    }

    const rawData = dataLines.join('\n');
    let payload = rawData;

    if (rawData) {
      try {
        payload = JSON.parse(rawData);
      } catch {
        // keep raw text payload
      }
    }

    onEvent({ event: currentEvent || 'message', id: currentId, payload, rawData });

    currentEvent = 'message';
    currentId = null;
    dataLines = [];
  };

  return {
    feed: (chunk) => {
      buffer += String(chunk || '');

      while (true) {
        const newlineIndex = buffer.indexOf('\n');

        if (newlineIndex < 0) {
          break;
        }

        let line = buffer.slice(0, newlineIndex);
        buffer = buffer.slice(newlineIndex + 1);

        if (line.endsWith('\r')) {
          line = line.slice(0, -1);
        }

        if (!line) {
          flushEvent();
          continue;
        }

        if (line.startsWith(':')) {
          continue;
        }

        if (line.startsWith('event:')) {
          currentEvent = line.slice(6).trim() || 'message';
          continue;
        }

        if (line.startsWith('data:')) {
          dataLines.push(line.slice(5).trimStart());
          continue;
        }

        if (line.startsWith('id:')) {
          currentId = line.slice(3).trim();
          continue;
        }

        dataLines.push(line.trim());
      }
    },
    flush: () => {
      if (buffer.trim()) {
        dataLines.push(buffer.trim());
        buffer = '';
      }

      flushEvent();
    }
  };
};

export default createSseParser;
